// Google Analytics utility functions

// Check if analytics consent is granted
const hasAnalyticsConsent = () => {
  try {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      const preferences = JSON.parse(cookieConsent);
      return preferences.analytics === true;
    }
  } catch (e) {
    console.error('Error checking analytics consent:', e);
  }
  return false;
};

// Track page views
export const trackPageView = (path) => {
  if (hasAnalyticsConsent() && typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (action, category = 'engagement', label = '', value = 0) => {
  if (hasAnalyticsConsent() && typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track article views
export const trackArticleView = (articleId, articleTitle) => {
  if (hasAnalyticsConsent()) {
    trackEvent('view_article', 'content', `${articleTitle} (ID: ${articleId})`);
  }
};

// Track character interactions
export const trackCharacterInteraction = (characterName) => {
  if (hasAnalyticsConsent()) {
    trackEvent('character_interaction', 'engagement', characterName);
  }
};

// Track mission page views
export const trackMissionView = () => {
  if (hasAnalyticsConsent()) {
    trackEvent('mission_view', 'content', 'Mission Page');
  }
};
